const initialState = {
  readNotifications: [],
  unreadNotifications: [],
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_READ_NOTIFICATIONS":
      return {
        ...state,
        readNotifications: action.payload,
      };
    case "GET_UNREAD_NOTIFICATIONS":
      return {
        ...state,
        unreadNotifications: action.payload,
      };
    default:
      return state;
  }
};

export default notificationsReducer;
